<template>
    <project-template>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>The Backstory</h1>
          <p>The Bipartisan Policy Center contacted Milk* to create a simple and minimalistic resource and information site for the MyHealthyWeight initiative. My role on this project was to develop the style and UI of the website, along with a working version of the site which would then be ported into a custom Wordpress theme. I started by developing desktop and mobile wireframes for the main resource page, and sent them to the client for approval.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/myhealthyweight/wireframes.jpg"
        alt="MyHealthyWeight Wireframes"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>A Fresh Coat of Paint</h1>
          <p>Due to the fairly straightforward nature of the website, the wireframes were quickly finalized. The next step was to turn those wireframes into high-fidelity screens, which would dictate the final appearance of the MyHealthyWeight site. I decided upon a bright and approachable color scheme and sourced easily interpretable iconography.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/myhealthyweight/designs.jpg"
        alt="MyHealthyWeight Designs"/>

        <project-text
        size="25"
        :color="$store.state.activeProject.color">
          <h1>Making it Work</h1>
          <p>Once the look and feel of the site was approved, I developed a working responsive version of the site using HTML, Sass, and vanilla Javascript. My final delivery of the MyHealthyWeight website contained the main resource section with working filters, an interior page template, and a request access feature that locked hidden information to the public.<br> <br> This version of the site was then passed off to a freelance back-end developer to port into a WordPress theme and integrate the MyHealthyWeight resource database. The site is now maintained by the Bipartisan Policy Center.</p>
        </project-text>

        <project-image
        size="75"
        path="/img/p/myhealthyweight/desktop.jpg"
        alt="MyHealthyWeight Live Site"/>

    </project-template>
</template>

<script>
import ProjectTemplate from '../../components/project/ProjectTemplate.vue'
import ProjectImage from '../../components/project/ProjectImage.vue'
import ProjectText from '../../components/project/ProjectText.vue'

export default {
  components: { ProjectTemplate, ProjectText, ProjectImage }
}
</script>

<style lang="scss" scoped>

</style>
